import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Layout from '../components/Layout';

const RATINGS = [
  { value: 'bad', className: 'btn-bad', label: '다신 사용 안한다' },
  { value: 'soso', className: 'btn-soso', label: '아직 잘 모르겠다' },
  { value: 'good', className: 'btn-good', label: '쓸만하다' },
];

const Comment = (props) => {
  const navigate = useNavigate();
  const [rating, setRating] = useState(null);
  const [content, setContent] = useState('');
  const [sending, setSending] = useState(false);

  const handleSubmit = async () => {
    if (!rating && !content.trim()) {
      alert('평가를 선택하거나 내용을 입력해주세요.');
      return;
    }
    setSending(true);
    try {
      await axios.post('/api/feedback', { rating, content });
      alert('소중한 의견 감사합니다!');
      navigate('/Main');
    } catch (err) {
      alert(err.response?.data?.error || '전송에 실패했습니다. 잠시 후 다시 시도해주세요.');
      setSending(false);
    }
  };

  return (
		<Layout header={{ title: '두벅이 소리함', Backbtn: true, link: '/Profile' }} containName='comment'>
      <div className='comment-top'>
        <div className='comment-text'>
          <h2>소중한 의견을 들려주세요!</h2>
          <p>사용하시면서 불편한 점이 있으셨나요?<br/>
          혹은, 이런 부분을 개선됐으면 좋겠다 하는 점이 있으셨나요?<br/>
          다양한 의견을 들려주세요.</p>
        </div>

        <ul className='emotion-wrap'>
          {RATINGS.map(r => (
            <li key={r.value}>
              <button type='button' className={`${r.className} ${rating === r.value ? 'active' : ''}`} onClick={() => setRating(r.value)}>{r.label}</button>
            </li>
          ))}
        </ul>
      </div>

      <div className='comment-textarea'>
        <strong className='title'>불편 및 개선 내용</strong>
        <textarea placeholder='불편했거나 개선하길 원하는 내용을 적어주세요.' value={content} onChange={e => setContent(e.target.value)} maxLength={2000}></textarea>
      </div>

      <div className='btn-bottom'>
        <button type='button' className='btn' onClick={handleSubmit} disabled={sending}>충고하기</button>
      </div>

		</Layout>
  );
};

export default Comment;
